import React from "react";
import { Document, Page, Text, View, StyleSheet, Font, Image } from "@react-pdf/renderer";
import moment from "moment";
import logo from "../../img/logoNoText.png";

// Font.register({
//     family: "Oswald",
//     src: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf"
// });
// https://github.com/google/fonts/raw/main/apache/roboto/static/Roboto-Medium.ttf
// Font.register({
//     family: 'Roboto',
//     fonts: [
//         // { src: 'https://raw.githubusercontent.com/google/fonts/main/apache/roboto/static/Roboto-Light.ttf', fontWeight: 300 },
//         { src: 'https://raw.githubusercontent.com/google/fonts/main/apache/roboto/static/Roboto-Regular.ttf', fontWeight: 400 }, // font-style: normal, font-weight: normal
//         { src: 'https://raw.githubusercontent.com/google/fonts/main/apache/roboto/static/Roboto-Medium.ttf', fontWeight: 500 },
//         { src: 'https://raw.githubusercontent.com/google/fonts/main/apache/roboto/static/Roboto-Bold.ttf', fontWeight: 700 },
//     ]
// });
// Font.register({
//     family: 'Roboto', fonts: [
//         { src: '/RobotoFont/Roboto-Light.ttf', fontWeight: 300 },
//         // { src: '/RobotoFont/Roboto-Regular.ttf', fontWeight: 400 }, // font-style: normal, font-weight: normal
//         { src: '/RobotoFont/Roboto-Medium.ttf', fontWeight: 500 },
//         { src: '/RobotoFont/Roboto-Bold.ttf', fontWeight: 700 },
//     ]
// });

const styles = StyleSheet.create({
    page: {
        // fontFamily: 'Roboto',
        fontWeight: 400,
        flexDirection: "column",
        color: "#000",
        fontSize: "12px",
        lineHeight: "1.4em",
        minHeight: "100vh",
        position: "relative"
    },

    // global
    textRight: {
        textAlign: "right"
    },
    textCenter: {
        textAlign: "center"
    },
    fw400: {
        fontWeight: "400"
    },
    fw500: {
        fontWeight: "500"
    },
    fw600: {
        fontWeight: "600"
    },
    fw700: {
        fontWeight: "700"
    },
    border2Left: {
        border: "solid",
        borderLeft: "1px",
        borderColor: "#EDEDF3"
    },
    borderLeft: {
        border: "solid",
        borderLeft: "1px",
        borderColor: "#D1D7FF"
    },
    borderRight: {
        border: "solid",
        borderRight: "1px",
        borderColor: "#D1D7FF"
    },
    borderBottom: {
        border: "solid",
        borderBottom: "1px",
        borderColor: "#D1D7FF"
    },
    border: {
        border: "solid",
        borderWidth: "1px",
        borderColor: "#D1D7FF"
    },
    // table
    table: {
        // border: 'solid',
        // borderWidth: '1px',
        // borderColor: '#DFE4FF'
    },
    tableHeadRow: {
        backgroundColor: "#DFE4FF",
        color: "#4352BB",
        fontWeight: "500",
        display: "flex",
        flexDirection: "row",
        border: "solid",
        borderBottom: "1px",
        borderColor: "#DFE4FF"
    },
    tableBodyRow: {
        display: "flex",
        flexDirection: "row"
    },
    tableCol: {
        padding: "5px 10px"
    },
    w30: {
        width: "30%"
    },
    w33: {
        width: "33%"
    },
    w40: {
        width: "40%"
    },
    w60: {
        width: "60%"
    },
    w70: {
        width: "70%"
    },
    w15px: {
        width: "15px"
    },
    purpleTitle: {
        backgroundColor: "#DFE4FF",
        color: "#4D5DCC",
        textAlign: "center",
        padding: "5px"
    },
    textTotal: {
        fontSize: "16px",
        color: "#4D5DCC",
        fontWeight: "700"
    },
    listIcon: {
        backgroundColor: "#000",
        width: "5px",
        height: "5px",
        borderRadius: "50%",
        marginTop: "4px"
    },
    marginBot5: {
        marginBottom: "5px"
    },
    marginBot10: {
        marginBottom: "10px"
    },
    marginBot15: {
        marginBottom: "15px"
    },
    marginBot20: {
        marginBottom: "20px"
    },
    marginBot30: {
        marginBottom: "30px"
    },

    // header
    pageHeader: {
        backgroundColor: "#4D5DCC",
        color: "#fff",
        padding: "10px",
        textAlign: "center",
        fontWeight: 300
    },
    secLogo: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center"
    },
    secLogoIn: {
        width: "70px",
        height: "70px",
        borderRadius: "50%",
        border: "solid",
        borderColor: "#6575E3",
        borderWidth: "5px",
        marginBottom: "5px",
        overflow: "hidden"
    },
    logo: {
        width: "60px",
        height: "60px",
        borderRadius: "50%"
    },
    pageTitle: {
        fontSize: "18px",
        fontWeight: "500"
    },

    headerInfo: {
        padding: "20px",
        display: "flex",
        flexDirection: "row",
        alignItems: "start",
        justifyContent: "space-between"
    },
    clientInfo: {
        // width: '60%'
    },
    invoiceInfo: {
        // width: '40%',
        textAlign: "left"
    },

    // main
    pageMain: {
        padding: "0 30px 30px"
    },
    invoiceTitle: {
        fontSize: "20",
        textAlign: "center"
    },

    // footer
    pageFooter: {
        backgroundColor: "#4D5DCC",
        color: "#B7C0FF",
        fontSize: "10px",
        padding: "5px",
        textAlign: "center",
        position: "absolute",
        bottom: "0",
        left: "0",
        width: "100%"
    }
});

const getField = (name, prop) => {
    let l = "";
    prop.forEach(field => {
        if (field.name === name) l = field.value;
    });
    return l;
};

const comma = n => {
    const a = Math.floor(n);
    const b = Math.floor(10 * (n - a));
    const c = Math.floor(100 * (n - a)) - 10 * b;
    return a + "," + b + "" + c;
};

const getCompanyInfo = (props, key) => {
    const { company, therapist } = props;
    // return company info
    return company ? company[key] : therapist[key];
};

export const getInvoiceNumber = props => {
    let invoiceNumber =
        "" +
        (props.number !== undefined
            ? props.number
            : props.company
            ? props.company.invoiceCount
            : props.therapist.invoiceCount);

    if (invoiceNumber.length < 4) {
        invoiceNumber = "0" + invoiceNumber;
    }
    return invoiceNumber;
};

export default props => {
    return (
        <Page size="A4" key={props?.id} style={styles.page}>
            <View style={styles.pageHeader}>
                <View style={styles.secLogo}>
                    <View style={styles.secLogoIn}>
                        <Image
                            style={styles?.logo}
                            src={props.company ? props.company?.logo || logo : props.therapist?.logo || logo}></Image>
                    </View>
                </View>
                <Text style={styles.pageTitle}>
                    {" "}
                    {props.company ? props.company.companyName : props.therapist.companyName}{" "}
                </Text>
            </View>

            <View style={styles.headerInfo}>
                <View style={styles.clientInfo}>
                    <Text>
                        {props.client.nameFirst} {props.client.nameLast} {"\n"}
                        {props.client.address} {"\n"}
                        {props.client.post} {props.client.town}
                        {"\n"}
                        CPR: {props.client.CPR.substring(0, 6)} - {props.client.CPR.substring(6)}
                        {"\n"}
                    </Text>
                </View>
                <View style={styles.invoiceInfo}>
                    <Text>
                        Fakturanr.: {getInvoiceNumber(props)}
                        {"\n"}
                        Dato: {moment(Number(props.booking.from)).format("DD/MM/YYYY")}
                    </Text>
                </View>
            </View>

            <View style={styles.pageMain}>
                <Text style={[styles.invoiceTitle, styles.marginBot10]}>
                    {props.settings.type ? "Faktura" : "Kreditnota"}
                </Text>
                <View style={[styles.bookingInfo, styles.marginBot15]}>
                    <Text style={styles.textCenter}>
                        Du blev d. {moment(Number(props.booking.from)).format("DD/MM/YYYY")} kl.{" "}
                        {moment(Number(props.booking.from)).format("HH:mm")} behandlet af {props.therapist.nameFirst}{" "}
                        {props.therapist.nameLast}.
                    </Text>
                </View>

                <View style={[styles.table, styles.marginBot15]}>
                    <View style={styles.tableHeadRow}>
                        <Text style={[styles.tableCol, styles.w40]}>Behandling</Text>
                        <Text style={[styles.tableCol, styles.w30, styles.border2Left, styles.textCenter]}>
                            Varighed
                        </Text>
                        <Text style={[styles.tableCol, styles.w30, styles.border2Left, styles.textRight]}>Pris</Text>
                    </View>
                    <View style={[styles.tableBodyRow, styles.border]}>
                        <Text style={[styles.tableCol, styles.w40]}>{props.treatment.name}</Text>
                        <Text style={[styles.tableCol, styles.w30, styles.borderLeft, styles.textCenter]}>
                            {props.treatment.duration / 60} min
                        </Text>
                        <Text style={[styles.tableCol, styles.w30, styles.borderLeft, styles.textRight]}>
                            {comma(props.treatment.price)} DKK
                        </Text>
                    </View>
                    {props.settings.discount ? (
                        <View style={styles.tableBodyRow}>
                            <Text style={[styles.tableCol, styles.w70, styles.textRight, styles.fw600]}>Rabat:</Text>
                            <Text style={[styles.tableCol, styles.w30, styles.textRight, styles.fw600]}>
                                {comma(props.settings.discount)} DKK
                            </Text>
                        </View>
                    ) : (
                        <></>
                    )}
                    {props.settings.moms ? (
                        <View style={styles.tableBodyRow}>
                            <Text style={[styles.tableCol, styles.w70, styles.textRight, styles.fw600]}>Moms 25%:</Text>
                            <Text style={[styles.tableCol, styles.w30, styles.textRight, styles.fw600]}>
                                {comma((props.treatment.price - (props.settings.discount || 0)) * 0.25)} DKK
                            </Text>
                        </View>
                    ) : (
                        <></>
                    )}
                    <View style={styles.tableBodyRow}>
                        <Text style={[styles.tableCol, styles.w70, styles.textRight, styles.textTotal]}>I alt:</Text>
                        <Text style={[styles.tableCol, styles.w30, styles.textRight, styles.textTotal]}>
                            {comma(
                                props.treatment.price -
                                    (props.settings.discount || 0) +
                                    (props.settings.moms
                                        ? (props.treatment.price - (props.settings.discount || 0)) * 0.25
                                        : 0)
                            )}{" "}
                            DKK
                        </Text>
                    </View>
                </View>

                {/* Aktuel behandling */}
                {props.settings.aktuelBehandling !== false ? (
                    props.journal ? (
                        <View style={styles.marginBot15}>
                            <View style={[styles.tableBodyRow, styles.marginBot5]}>
                                <View style={styles.w15px}>
                                    <Text style={styles.listIcon}></Text>
                                </View>
                                <Text style={styles.text}>Aktuel behandling</Text>
                            </View>
                            <View style={styles.tableBodyRow}>
                                <Text style={styles.w15px}></Text>
                                <Text>{props.journal.treatment}</Text>
                            </View>
                        </View>
                    ) : (
                        <View style={styles.marginBot15}>
                            <View style={[styles.tableBodyRow, styles.marginBot5]}>
                                <View style={styles.w15px}>
                                    <Text style={styles.listIcon}></Text>
                                </View>
                                <Text style={styles.text}>Aktuel behandling</Text>
                            </View>
                            <View style={styles.tableBodyRow}>
                                <Text style={styles.w15px}></Text>
                                <Text>{getField("Aktuel behandling", props.stamJournal)}</Text>
                            </View>
                        </View>
                    )
                ) : (
                    <></>
                )}

                {/* followUpText */}
                {props.settings.followUpText ? (
                    props.journal ? (
                        <View style={styles.marginBot15}>
                            <View style={[styles.tableBodyRow, styles.marginBot5]}>
                                <View style={styles.w15px}>
                                    <Text style={styles.listIcon}></Text>
                                </View>
                                <Text style={styles.text}>Opfølgende behandling</Text>
                            </View>
                            <View style={styles.tableBodyRow}>
                                <Text style={styles.w15px}></Text>
                                <Text>{props.journal.followUp}</Text>
                            </View>
                        </View>
                    ) : (
                        <View style={styles.marginBot15}>
                            <View style={[styles.tableBodyRow, styles.marginBot5]}>
                                <View style={styles.w15px}>
                                    <Text style={styles.listIcon}></Text>
                                </View>
                                <Text style={styles.text}>Opfølgende behandling</Text>
                            </View>
                            <View style={styles.tableBodyRow}>
                                <Text style={styles.w15px}></Text>
                                <Text>{getField("Opfølgende behandling", props.stamJournal)}</Text>
                            </View>
                        </View>
                    )
                ) : (
                    <></>
                )}

                {/* upComing */}
                {props.upComing ? (
                    <View style={styles.marginBot15}>
                        <View style={[styles.tableBodyRow, styles.marginBot5]}>
                            <View style={styles.w15px}>
                                <Text style={styles.listIcon}></Text>
                            </View>
                            <Text style={styles.text}>Kommende aftaler</Text>
                        </View>
                        <View>
                            {props.upComing.map(booking => {
                                const isUpcomingDate = moment(Number(booking.from)).isAfter(moment());
                                return isUpcomingDate ? (
                                    <View style={styles.tableBodyRow}>
                                        <Text style={styles.w15px}></Text>
                                        <Text> D. {moment(Number(booking.from)).format("DD/MM/YYYY, HH:mm:ss")}</Text>
                                    </View>
                                ) : null;
                            })}
                        </View>
                    </View>
                ) : (
                    <></>
                )}
                <View style={styles.marginBot10}></View>
                <View style={[styles.purpleTitle, styles.marginBot30]}>
                    <Text>Betaling efter afsluttet behandling, hvis ikke andet er aftalt.</Text>
                </View>

                <View style={[styles.tableBodyRow]}>
                    <Text style={[styles.tableCol, styles.w33, styles.border]}>
                        MobilePay: {getCompanyInfo(props, "mobilePay") ? getCompanyInfo(props, "mobilePay") : <></>}
                    </Text>
                    <Text style={styles.w15px}></Text>
                    <Text style={[styles.tableCol, styles.w33, styles.border]}>
                        Bankreg: {getCompanyInfo(props, "regNumber") ? getCompanyInfo(props, "regNumber") : <></>}
                    </Text>
                    <Text style={styles.w15px}></Text>
                    <Text style={[styles.tableCol, styles.w33, styles.border]}>
                        Kontonr:{" "}
                        {getCompanyInfo(props, "accountNumber") ? getCompanyInfo(props, "accountNumber") : <></>}
                    </Text>
                </View>
            </View>

            <View style={styles.pageFooter}>
                <Text>
                    {getCompanyInfo(props, "companyName")}, {getCompanyInfo(props, "address")},{" "}
                    {getCompanyInfo(props, "zipCode")} {getCompanyInfo(props, "town")}
                </Text>
                <Text>
                    CVR: {getCompanyInfo(props, "CVR").trim()} - {getCompanyInfo(props, "email")} -{" "}
                    {getCompanyInfo(props, "phone")}
                </Text>
            </View>
        </Page>
    );
};
